import {ALookupRowsContainer} from "./lookup.rows.container";

export class ScanDocument extends ALookupRowsContainer {
	scanDocumentKey: number;
	personKey: number;
	orderKey: number;
	pageCount?:number;
	pageNumber?:number;
	scannedDate: Date;
	description: string;
	scannedByPersonKey: number;
	scanDocTypeKey: number;
	appointmentId: string;
	docExtension: string;
	contents: any;

	isChanged?: boolean;
}
